export const LoginConstant={
    
    REQUIRED_FIELD:'Username/Email is required',
    PASSWORD_FIELD:"Password is required",
    USER_NOT_VALID:"PAPI could not be reached.",
    EMAIL_REQUIRED: "Please fill out this field.",
    EMAIL_FORMAT: "Please enter valid email id",
   
}
